{combineReducers} = require 'redux'

module.exports = combineReducers
  store: require './store'
